import React, { useState, useEffect, useRef, useCallback } from "react";
import axios from "axios";
import {
  Navbar,
  Container,
  Nav,
  Dropdown,
  ProgressBar,
  Col,
  Row,
} from "react-bootstrap";
import { useNavigate, useLocation } from "react-router-dom";

import { toast } from "react-toastify";
import { TUTOR_ONBOARDING_API } from "../../../api/api";

import { FaChevronDown, FaUser, FaVideo, FaFile } from "react-icons/fa";
import { MdInfo } from "react-icons/md";
import { FiChevronLeft } from "react-icons/fi";
import { FaFileArrowUp } from "react-icons/fa6";

import Logo from "../../../assets/Skilledition-logo.png";

// Real (default) icons
import photoIcon from "../../../assets/photo-icon.png";
import certificateIcon from "../../../assets/certificate-icon.png";
import educationIcon from "../../../assets/education-icon.png";
import experienceIcon from "../../../assets/experience-icon.png";
import videoIcon from "../../../assets/video-icon.png";
import descriptionIcon from "../../../assets/description-icon.png";
import pricingIcon from "../../../assets/pricing-icon.png";
import reviewIcon from "../../../assets/review-icon.png";

// Active (selected) background icons
import bgAboutIcon from "../../../assets/bg-about-icon.png";
import bgPhotoIcon from "../../../assets/bg-photo-icon.png";
import bgCertificateIcon from "../../../assets/bg-certificate-icon.png";
import bgEducationIcon from "../../../assets/bg-education-icon.png";
import bgExperienceIcon from "../../../assets/bg-experience-icon.png";
import bgVideoIcon from "../../../assets/bg-video-icon.png";
import bgDescriptionIcon from "../../../assets/bg-description-icon.png";
import bgPricingIcon from "../../../assets/bg-pricing-icon.png";
import bgReviewIcon from "../../../assets/bg-review-icon.png";

//icon
import completed from "../../../assets/check-circle-icon.png";
// import profilePhoto from "../../../assets/photo-up.jpg";
import editIcon from "../../../assets/Edit-icon.png";

import { handleApiError } from "../../../utils/apiErrorHandler";

import "./TutorOnboarding.css";

const steps = [
  { id: 1, label: "About", iconDefault: photoIcon, iconActive: bgAboutIcon },
  { id: 2, label: "Photo", iconDefault: photoIcon, iconActive: bgPhotoIcon },
  {
    id: 3,
    label: "Certificates",
    iconDefault: certificateIcon,
    iconActive: bgCertificateIcon,
  },
  {
    id: 4,
    label: "Education",
    iconDefault: educationIcon,
    iconActive: bgEducationIcon,
  },
  {
    id: 5,
    label: "Experience",
    iconDefault: experienceIcon,
    iconActive: bgExperienceIcon,
  },
  {
    id: 6,
    label: "Demo Video",
    iconDefault: videoIcon,
    iconActive: bgVideoIcon,
  },
  {
    id: 7,
    label: "Description",
    iconDefault: descriptionIcon,
    iconActive: bgDescriptionIcon,
  },
  {
    id: 8,
    label: "Pricing",
    iconDefault: pricingIcon,
    iconActive: bgPricingIcon,
  },
  { id: 9, label: "Review", iconDefault: reviewIcon, iconActive: bgReviewIcon },
];

const indianLanguages = [
  "Assamese",
  "Bengali",
  "Bodo",
  "Dogri",
  "Gujarati",
  "Hindi",
  "Kannada",
  "Kashmiri",
  "Konkani",
  "Maithili",
  "Malayalam",
  "Manipuri",
  "Marathi",
  "Nepali",
  "Odia",
  "Punjabi",
  "Sanskrit",
  "Santhali",
  "Sindhi",
  "Tamil",
  "Telugu",
  "English",
  "Urdu",
];

const TutorOnboarding = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const fileInputRef = useRef();

  const [tutorFullName, setTutorFullName] = useState("");
  const [formData, setFormData] = useState({
    firstName: "",
    // lastName: "",
    email: "",
    country: "",
    subject: "",
    language: "",
    level: "",
    phone: "",
  });
  const [uploadedPhoto, setUploadedPhoto] = useState(null); // for preview (Base64)
  const [photoFile, setPhotoFile] = useState(null); // for API upload
  const [certificates, setCertificates] = useState([]);
  const [educations, setEducations] = useState([]);
  const [experience, setExperience] = useState({
    yearsOfExperience: "",
    professionalBackground: "",
    achievements: "",
  });
  const [demoVideoData, setDemoVideoData] = useState({
    videoTitle: "",
    videoDescription: "",
  });
  const [demoVideoFile, setDemoVideoFile] = useState(null);
  const [description, setDescription] = useState({
    shortBio: "",
    teachingStyle: "",
    studentExpectations: "",
  });
  const [pricing, setPricing] = useState({
    paymentType: "oneTime",
    basePrice: "",
    bankInfo: "",
    // agreed: false,
  });
  const [rejectReason, setRejectReason] = useState(null);

  //initial store and track API data
  const [initialFormData, setInitialFormData] = useState(null); // store about for track API data
  const [initialCertificates, setInitialCertificates] = useState([]);
  const [initialEducations, setInitialEducations] = useState([]);
  const [initialExperience, setInitialExperience] = useState({
    yearsOfExperience: "",
    professionalBackground: "",
    achievements: "",
  });
  const [initialDemoVideoData, setInitialDemoVideoData] = useState({
    videoTitle: "",
    videoDescription: "",
  });
  const [initialDemoVideoFile, setInitialDemoVideoFile] = useState(null);
  const [initialDescription, setInitialDescription] = useState({
    shortBio: "",
    teachingStyle: "",
    studentExpectations: "",
  });
  const [initialPricing, setInitialPricing] = useState({
    paymentType: "oneTime",
    basePrice: "",
    bankInfo: "",
  });

  const [tutorId, setTutorId] = useState(null);
  const [demoVideoId, setDemoVideoId] = useState(null);

  const totalSteps = steps.length;
  const [currentStep, setCurrentStep] = useState(1);

  const progressPercent = (currentStep / totalSteps) * 100;

  // localStorage get ID's
  // const token = localStorage.getItem("token");
  // const userId = localStorage.getItem("user_id");
  // const tutorId = localStorage.getItem("tutor_id");
  // const demoVideoId = localStorage.getItem("demo_video_id");

  //loading
  const [isDemoVideoSubmitting, setIsDemoVideoSubmitting] = useState(false);

  // main toast error
  const showErrorToast = (message) => {
    toast.error(message, {
      position: "top-right",
      autoClose: 1500,
      theme: "colored",
    });
  };

  const getLastCompletedStep = (tutor) => {
    let step = 0;

    const td = tutor?.tutor_details;
    const dv = tutor?.demo_video;
    const pp = tutor?.payment_plan;

    // STEP 1 – About (ALL REQUIRED FIELDS)
    const isAboutCompleted =
      td?.full_name &&
      // td?.last_name &&
      td?.email &&
      td?.country &&
      td?.subject_to_teach &&
      td?.speak_language &&
      td?.level &&
      td?.phone_number;

    if (!isAboutCompleted) return step;
    step = 1;

    // STEP 2 – Photo
    if (!td?.profile_pic_url) return step;
    step = 2;

    // STEP 3 – Certificates
    if (!tutor?.certificates || tutor.certificates.length === 0) return step;
    step = 3;

    // STEP 4 – Education
    if (!tutor?.education || tutor.education.length === 0) return step;
    step = 4;

    // STEP 5 – Experience
    if (!td?.years_of_experience || !td?.professional_background) {
      return step;
    }
    step = 5;

    // STEP 6 – Demo Video (FILE + TITLE + DESCRIPTION)
    if (!dv?.video_file_url || !dv?.video_title || !dv?.video_description) {
      return step;
    }
    step = 6;

    // STEP 7 – Description
    if (!dv?.short_bio || !dv?.teaching_style || !dv?.student_can_expect) {
      return step;
    }
    step = 7;

    // STEP 8 – Pricing (PLAN + PRICE + BANK INFO)
    const isPricingCompleted = pp?.plan_type && pp?.price && pp?.upi_id;
    if (!isPricingCompleted) return step;
    step = 8;

    return 9;
  };

  useEffect(() => {
    if (location.state?.step) {
      setCurrentStep(location.state.step);
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  }, [location.state]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const isFormChanged = () => {
    //update about api
    if (!initialFormData) return true; // If no initial form data, assume form has been modified
    return Object.keys(formData).some(
      (key) => formData[key] !== initialFormData[key],
    );
  };

  // Handle changes in certificate fields
  const handleCertificateChange = (index, e) => {
    const { name, value, files } = e.target;
    const updatedCertificates = [...certificates];

    updatedCertificates[index] = {
      ...updatedCertificates[index],
      [name]: files ? files[0] : value,
    };

    setCertificates(updatedCertificates);
  };

  const isCertificatesChanged = () => {
    if (!initialCertificates.length && certificates.length) return true; // first add
    if (initialCertificates.length !== certificates.length) return true;

    return certificates.some((cert, index) => {
      const initCert = initialCertificates[index];
      return (
        cert.name !== initCert.name ||
        cert.issuedBy !== initCert.issuedBy ||
        cert.date !== initCert.date ||
        cert.file !== initCert.file
      );
    });
  };

  // Handle changes in education fields
  const handleEducationChange = (index, e) => {
    const { name, value } = e.target;
    const updatedEducations = [...educations];
    updatedEducations[index] = {
      ...updatedEducations[index],
      [name]: value,
    };
    setEducations(updatedEducations);
  };

  const isEducationsChanged = () => {
    if (!initialEducations.length && educations.length) return true; // first add
    if (initialEducations.length !== educations.length) return true;

    return educations.some((edu, index) => {
      const initEdu = initialEducations[index];
      return (
        edu.degree !== initEdu.degree ||
        edu.institution !== initEdu.institution ||
        edu.specialization !== initEdu.specialization ||
        edu.yearOfGraduation !== initEdu.yearOfGraduation
      );
    });
  };

  const handleExperienceChange = (e) => {
    const { name, value } = e.target;
    setExperience((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  // Check if experience data has changed
  const isExperienceChanged = () => {
    return (
      experience.yearsOfExperience !== initialExperience.yearsOfExperience ||
      experience.professionalBackground !==
        initialExperience.professionalBackground ||
      experience.achievements !== initialExperience.achievements
    );
  };

  const handleDemoVideoChange = (e) => {
    const { name, value } = e.target;
    setDemoVideoData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleDemoVideoFile = (file) => {
    setDemoVideoFile(file);
    // Reset demo video status for new upload
    setDemoVideoData((prev) => ({
      ...prev,
      status: "pending", // New upload is always pending
    }));
  };

  const handleRemoveDemoVideo = () => {
    setDemoVideoFile(null);
    // Reset file input so same file can be uploaded again
    const input = document.getElementById("demoVideoUpload");
    if (input) {
      input.value = "";
    }
  };

  const isDemoVideoChanged = () => {
    return (
      demoVideoData.videoTitle !== initialDemoVideoData.videoTitle ||
      demoVideoData.videoDescription !==
        initialDemoVideoData.videoDescription ||
      demoVideoFile !== initialDemoVideoFile
    );
  };

  const handleDescriptionChange = (e) => {
    const { name, value } = e.target;
    setDescription((prev) => ({ ...prev, [name]: value }));
  };

  const isDescriptionChanged = () => {
    return (
      description.shortBio !== initialDescription.shortBio ||
      description.teachingStyle !== initialDescription.teachingStyle ||
      description.studentExpectations !== initialDescription.studentExpectations
    );
  };

  const handlePricingChange = (e) => {
    const { name, value } = e.target;
    setPricing((prev) => ({ ...prev, [name]: value }));
  };

  const isPricingChanged = () => {
    return (
      pricing.paymentType !== initialPricing.paymentType ||
      pricing.basePrice !== initialPricing.basePrice ||
      pricing.bankInfo !== initialPricing.bankInfo
    );
  };

  const handlePhotoUpload = (event) => {
    const file = event.target.files[0];

    if (file && file.type.startsWith("image/")) {
      setPhotoFile(file); // store the actual file

      // Preview
      const reader = new FileReader();
      reader.onloadend = () => {
        setUploadedPhoto(reader.result);
      };
      reader.readAsDataURL(file);

      event.target.value = "";
    } else {
      showErrorToast("Please upload a valid image file (JPG or PNG).");
    }
  };

  const handleReplacePhoto = () => {
    fileInputRef.current?.click(); // open file manager
  };

  const handleEditClick = (stepNumber) => {
    setCurrentStep(stepNumber);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const handleSubmitAdminReview = async () => {
    const token = localStorage.getItem("token");
    const userId = localStorage.getItem("user_id");

    if (!token || !userId) {
      navigate("/signin");
      return;
    }

    if (!tutorId) {
      showErrorToast("Tutor not found. Please complete previous steps first.");
      return;
    }

    try {
      const payload = {
        sender_id: userId,
        type: "Tutor-Onboarding",
        type_id: tutorId,
        message: `New tutor ${formData.firstName} has completed their onboarding and is awaiting your approval.`,
        status: "Pending",
      };

      const response = await axios.post(
        TUTOR_ONBOARDING_API.TUTOR_ONBOARDING_NOTIFICATION,
        payload,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );

      const data = response.data;

      if (data.statusCode === 200) {
        toast.success(data.message, {
          position: "top-right",
          autoClose: 1500,
          theme: "colored",
        });

        // Wait for the data to refresh
        await fetchTutorOnboardingData();
        navigate("/tutor-dashboard-under-review");
      } else {
        // Handles 2xx but not 200
        showErrorToast(data.message);
      }
    } catch (error) {
      console.error("Error sending notification:", error);

      // CHECK (expiry / invalid token)
      handleApiError(error, navigate, showErrorToast, "/signin");
    }
  };

  useEffect(() => {
    // Prevent back button navigation
    const handlePopState = (event) => {
      window.history.pushState(null, "", window.location.pathname);
    };

    // Set initial state and add listener
    window.history.pushState(null, "", window.location.pathname);
    window.addEventListener("popstate", handlePopState);

    // Clean up
    return () => {
      window.removeEventListener("popstate", handlePopState);
    };
  }, []);

  const handleLogout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("user_id");
    localStorage.removeItem("userRole");

    navigate("/signin", { replace: true });
  };

  // validation
  const validateAboutForm = () => {
    if (
      // !formData.firstName ||
      // !formData.lastName ||
      // !formData.email ||
      !formData.country ||
      !formData.subject ||
      !formData.language ||
      !formData.level
      // !formData.phone
    ) {
      showErrorToast("Please fill out all required fields.");
      return false;
    }

    // if (!/^[a-zA-Z ]+$/.test(formData.firstName)) {
    //   showErrorToast("First Name is required alphabets only.");
    //   return false;
    // }

    // if (!/^[a-zA-Z ]+$/.test(formData.lastName)) {
    //   showErrorToast("last Name is required alphabets only.");
    //   return false;
    // }

    // Email Validation
    // const emailPattern = /^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}$/;
    // if (!emailPattern.test(formData.email)) {
    //   showErrorToast("Enter a valid email address.");
    //   return false;
    // }

    // Phone Number Validation
    // const phonePattern = /^[6-9]\d{9}$/;
    // if (!phonePattern.test(formData.phone)) {
    //   showErrorToast("Enter a valid 10-digit mobile number.");
    //   return false;
    // }

    if (!formData.language || !/^[a-zA-Z ,]+$/.test(formData.language)) {
      showErrorToast("Language is required alphabets only.");
      return false;
    }

    // Age Confirmation
    const isAgeConfirmed = document.getElementById("confirmAge").checked;
    if (!isAgeConfirmed) {
      showErrorToast("You must confirm that you are 18 years of age.");
      return false;
    }

    return true;
  };

  const allowedRegex = /^[a-zA-Z .,'()&/-]+$/;

  const handleAboutSubmit = async (e) => {
    e.preventDefault();

    // Validation
    if (!validateAboutForm()) return;

    const token = localStorage.getItem("token");
    const userId = localStorage.getItem("user_id");

    if (!token || !userId) {
      navigate("/signin");
      return;
    }

    // Prepare data for API request
    const payload = {
      // first_name: formData.firstName,
      // last_name: formData.lastName,
      // email: formData.email,
      country: formData.country,
      subject_to_teach: formData.subject,
      speak_language: formData.language,
      // phone_number: formData.phone,
      user_id: userId,
      level: formData.level,
    };

    try {
      const response = await axios.post(
        TUTOR_ONBOARDING_API.TUTOR_ONBOARDING_ABOUT_ADD,
        payload,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );

      const data = response.data;

      if (data.statusCode === 200) {
        toast.success(data.message, {
          position: "top-right",
          autoClose: 1500,
          theme: "colored",
        });

        // Reset form fields after successful submission
        setFormData({
          // firstName: "",
          // lastName: "",
          // email: "",
          country: "",
          subject: "",
          language: "",
          level: "",
          // phone: "",
        });
        fetchTutorOnboardingData();
        setCurrentStep((prevStep) => Math.min(totalSteps, prevStep + 1)); // Move to the next step
      } else {
        // This will handle any 2xx response that is not 201
        showErrorToast(data.message);
      }
    } catch (error) {
      console.error("Error tutor details onboarding:", error);
      // Server responded with non-2xx status (like 400, 500)

      // CHECK (expiry / invalid token)
      handleApiError(error, navigate, showErrorToast, "/signin");
    }
  };

  const handlePhotoAddOrUpdate = async () => {
    const token = localStorage.getItem("token");

    if (!token) {
      navigate("/signin");
      return;
    }

    if (!photoFile) {
      showErrorToast("Please upload a photo before continuing.");
      return;
    }

    if (!tutorId) {
      showErrorToast("Tutor not found. Please complete previous steps first.");

      return;
    }

    const formData = new FormData();
    formData.append("profile_pic", photoFile);
    formData.append("tutor_id", tutorId);

    try {
      const response = await axios.post(
        TUTOR_ONBOARDING_API.TUTOR_ONBOARDING_PROFILE_ADD_AND_UPDATE,
        formData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );

      const data = response.data;

      if (data.statusCode === 200) {
        toast.success(data.message, {
          position: "top-right",
          autoClose: 1500,
          theme: "colored",
        });
        fetchTutorOnboardingData();
        setPhotoFile(null);
        setCurrentStep((prevStep) => Math.min(totalSteps, prevStep + 1)); // Move to next step
      } else {
        // This will handle any 2xx response that is not 201
        showErrorToast(data.message);
      }
    } catch (error) {
      console.error("Error uploading photo:", error);
      // Server responded with non-2xx status (like 400, 500)

      // CHECK (expiry / invalid token)
      handleApiError(error, navigate, showErrorToast, "/signin");
    }
  };

  const handleCertificateSubmit = async () => {
    if (certificates.length === 0) {
      showErrorToast("Please add at least one certificate before continuing.");
      return;
    }

    // Optional: check if all required fields in certificates are filled
    for (let i = 0; i < certificates.length; i++) {
      const cert = certificates[i];

      if (!cert.name || !cert.issuedBy || !cert.date || !cert.file) {
        showErrorToast(`Please complete all fields for Certificate ${i + 1}.`);
        return;
      }

      const today = new Date().toISOString().split("T")[0];
      if (cert.date > today) {
        showErrorToast(`Certificate ${i + 1} date cannot be in the future.`);
        return;
      }

      // Validate name
      if (!allowedRegex.test(cert.name)) {
        showErrorToast(
          `Certificate Name in Certificate ${i + 1} should contain only alphabets.`,
        );
        return;
      }

      // Validate name
      if (!allowedRegex.test(cert.issuedBy)) {
        showErrorToast(
          `Issued By in Certificate ${i + 1} should contain only alphabets.`,
        );
        return;
      }
    }

    // Check for duplicates
    const hasDuplicate = certificates.some((cert, i) =>
      certificates
        .slice(i + 1)
        .some(
          (c) =>
            c.name === cert.name &&
            c.issuedBy === cert.issuedBy &&
            c.date === cert.date,
        ),
    );
    if (hasDuplicate) {
      showErrorToast(
        "Duplicate certificates detected. Please remove duplicates.",
      );
      return;
    }

    const token = localStorage.getItem("token");

    if (!token) {
      navigate("/signin");
      return;
    }

    if (!tutorId) {
      showErrorToast("Tutor not found. Please complete previous steps first.");
      return;
    }

    const formData = new FormData();
    formData.append("tutor_id", tutorId);

    const certsMeta = certificates.map((cert) => ({
      certificate_name: cert.name,
      issued_by: cert.issuedBy,
      // date_of_issue: cert.date,
      date_of_issue: new Date(cert.date).toISOString().split("T")[0],
    }));

    formData.append("certificates", JSON.stringify(certsMeta));

    // Append each file separately
    certificates.forEach((cert) => {
      formData.append("certificate_file", cert.file);
    });

    try {
      const response = await axios.post(
        TUTOR_ONBOARDING_API.TUTOR_ONBOARDING_CERTIFICATE_ADD,
        formData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );

      const data = response.data;

      if (data.statusCode === 200) {
        toast.success(data.message, {
          position: "top-right",
          autoClose: 1500,
          theme: "colored",
        });
        fetchTutorOnboardingData();
        setCurrentStep((prevStep) => Math.min(totalSteps, prevStep + 1)); // Move to next step
      } else {
        // This will handle any 2xx response that is not 201
        showErrorToast(data.message);
      }
    } catch (error) {
      console.error("Error adding certificates:", error);
      // Server responded with non-2xx status (like 400, 500)

      // CHECK (expiry / invalid token)
      handleApiError(error, navigate, showErrorToast, "/signin");
    }
  };

  const handleEducationSubmit = async () => {
    if (educations.length === 0) {
      showErrorToast("Please add at least one education before continuing.");
      return;
    }

    const usedYears = new Set();

    // Optional: Check if all required fields in educations are filled
    for (let i = 0; i < educations.length; i++) {
      const edu = educations[i];
      if (
        !edu.degree ||
        !edu.institution ||
        !edu.specialization ||
        !edu.yearOfGraduation
      ) {
        showErrorToast(`Please complete all fields for Education ${i + 1}.`);
        return;
      }

      // Validate alphabetic fields
      if (!allowedRegex.test(edu.degree)) {
        showErrorToast(
          `Degree in Education ${i + 1} should contain only alphabets.`,
        );
        return;
      }

      // Validate alphabetic fields
      if (!allowedRegex.test(edu.institution)) {
        showErrorToast(
          `Institution in Education ${i + 1} should contain only alphabets.`,
        );
        return;
      }

      // Validate alphabetic fields
      if (!allowedRegex.test(edu.specialization)) {
        showErrorToast(
          `Specialization in Education ${i + 1} should contain only alphabets.`,
        );
        return;
      }

      // NEW: Check if year already used
      if (usedYears.has(edu.yearOfGraduation)) {
        showErrorToast(
          `Year of Graduation ${edu.yearOfGraduation} is already used. Please select a different year.`,
        );
        return;
      } else {
        usedYears.add(edu.yearOfGraduation);
      }
    }

    const token = localStorage.getItem("token");

    if (!token) {
      navigate("/signin");
      return;
    }

    if (!tutorId) {
      showErrorToast("Tutor not found. Please complete previous steps first.");
      return;
    }

    const payload = {
      tutor_id: tutorId,
      education: educations.map((edu) => ({
        degree: edu.degree,
        institution: edu.institution,
        specialization: edu.specialization,
        year_of_passout: edu.yearOfGraduation,
      })),
    };

    try {
      const response = await axios.post(
        TUTOR_ONBOARDING_API.TUTOR_ONBOARDING_EDUCATION_ADD,
        payload,
        {
          headers: { Authorization: `Bearer ${token}` },
        },
      );

      const data = response.data;

      if (data.statusCode === 200) {
        toast.success(data.message, {
          position: "top-right",
          autoClose: 1500,
          theme: "colored",
        });
        fetchTutorOnboardingData();
        setCurrentStep((s) => Math.min(totalSteps, s + 1));
      } else {
        // This will handle any 2xx response that is not 201
        showErrorToast(data.message);
      }
    } catch (error) {
      console.error("Error adding education:", error);
      // Server responded with non-2xx status (like 400, 500)

      // CHECK (expiry / invalid token)
      handleApiError(error, navigate, showErrorToast, "/signin");
    }
  };

  const handleExperienceAddOrUpdate = async () => {
    if (!experience.yearsOfExperience || !experience.professionalBackground) {
      showErrorToast("Please fill out all required fields before continuing.");
      return;
    }

    // Minimum length validation for professionalBackground
    if (experience.professionalBackground.length < 30) {
      showErrorToast("Professional Background must be at least 30 characters.");
      return;
    }

    // Validate professionalBackground (must contain letters, cannot be only numbers)
    if (!/[a-zA-Z]/.test(experience.professionalBackground)) {
      showErrorToast(
        "Professional Background / Expertise must contain letters.",
      );
      return;
    }

    // Validate achievements if provided (same as professionalBackground)
    if (experience.achievements && !/[a-zA-Z]/.test(experience.achievements)) {
      showErrorToast("Achievements must contain letters.");
      return;
    }

    const token = localStorage.getItem("token");

    if (!token) {
      navigate("/signin");
      return;
    }

    if (!tutorId) {
      showErrorToast("Tutor not found. Please complete previous steps first.");
      return;
    }

    const payload = {
      tutor_id: tutorId,
      years_of_experience: experience.yearsOfExperience,
      professional_background: experience.professionalBackground.trim(),
      achievements: experience.achievements || "",
    };

    try {
      const response = await axios.post(
        TUTOR_ONBOARDING_API.TUTOR_ONBOARDING_EXPERIENCE_ADD_AND_UPDATE,
        payload,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );

      const data = response.data;

      if (data.statusCode === 200) {
        toast.success(data.message, {
          position: "top-right",
          autoClose: 1500,
          theme: "colored",
        });
        fetchTutorOnboardingData();
        setInitialExperience(experience);
        setCurrentStep((s) => Math.min(totalSteps, s + 1)); // Move to next step
      } else {
        // This will handle any 2xx response that is not 201
        showErrorToast(data.message);
      }
    } catch (error) {
      console.error("Error updating professional details:", error);
      // Server responded with non-2xx status (like 400, 500)

      // CHECK (expiry / invalid token)
      handleApiError(error, navigate, showErrorToast, "/signin");
    }
  };

  const handleDemoVideoSubmit = async () => {
    if (isDemoVideoSubmitting) return;

    if (!demoVideoData.videoTitle || !demoVideoData.videoDescription) {
      showErrorToast("Please fill out both video title and description.");
      return;
    }

    if (!demoVideoFile) {
      showErrorToast("Please upload a demo video.");
      return;
    }

    // Validate alphabetic fields
    if (!allowedRegex.test(demoVideoData.videoTitle)) {
      showErrorToast("Video title should contain only letters.");
      return;
    }

    // Minimum length validation for professionalBackground
    if (demoVideoData.videoDescription.length < 30) {
      showErrorToast("Video description must be at least 30 characters.");
      return;
    }

    if (!/[a-zA-Z]/.test(demoVideoData.videoDescription)) {
      showErrorToast("Description must include at least one letter.");
      return;
    }

    // const isDemoVideoAgeConfirmed =
    //   document.getElementById("ageConfirm").checked;
    // if (!isDemoVideoAgeConfirmed) {
    //   showErrorToast("You must confirm that you are 18 years of age.");
    //   return;
    // }

    const token = localStorage.getItem("token");

    if (!token) {
      navigate("/signin");
      return;
    }

    if (!tutorId) {
      showErrorToast("Tutor not found. Please complete previous steps first.");
      return;
    }
    setIsDemoVideoSubmitting(true);
    const formData = new FormData();
    formData.append("tutor_id", tutorId);
    formData.append("video_title", demoVideoData.videoTitle.trim());
    formData.append("video_description", demoVideoData.videoDescription.trim());
    formData.append("video_file", demoVideoFile);

    try {
      const response = await axios.post(
        TUTOR_ONBOARDING_API.TUTOR_ONBOARDING_DEMO_VIDEO_ADD,
        formData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );

      const data = response.data;

      if (data.statusCode === 200) {
        toast.success(data.message, {
          position: "top-right",
          autoClose: 1500,
          theme: "colored",
        });
        fetchTutorOnboardingData();
        setCurrentStep((s) => Math.min(totalSteps, s + 1)); // Move to next step
      } else {
        // This will handle any 2xx response that is not 201
        showErrorToast(data.message);
      }
    } catch (error) {
      console.error("Error uploading demo video:", error);
      // Server responded with non-2xx status (like 400, 500)

      // CHECK (expiry / invalid token)
      handleApiError(error, navigate, showErrorToast, "/signin");
    } finally {
      setIsDemoVideoSubmitting(false);
    }
  };

  const handleDescriptionAddOrUpdate = async () => {
    if (
      !description.shortBio ||
      !description.teachingStyle ||
      !description.studentExpectations
    ) {
      showErrorToast("Please fill out all the required fields.");
      return;
    }

    if (description.shortBio.length < 30) {
      showErrorToast("Short bio must be at least 30 characters.");
      return;
    }

    if (!/[a-zA-Z]/.test(description.shortBio)) {
      showErrorToast("Short bio must include at least one letter.");
      return;
    }

    if (description.studentExpectations.length < 30) {
      showErrorToast("Student expectations must be at least 30 characters.");
      return;
    }

    if (!/[a-zA-Z]/.test(description.studentExpectations)) {
      showErrorToast("Student expectations must include at least one letter.");
      return;
    }

    if (!demoVideoId) {
      showErrorToast(
        "Demo video not found. Please complete previous steps first.",
      );
      return;
    }

    const token = localStorage.getItem("token");

    if (!token) {
      navigate("/signin");
      return;
    }

    const payload = {
      demo_video_id: demoVideoId,
      short_bio: description.shortBio,
      teaching_style: description.teachingStyle,
      student_can_expect: description.studentExpectations,
    };

    try {
      const response = await axios.post(
        TUTOR_ONBOARDING_API.TUTOR_ONBOARDING_DESCRIPTION_ADD_AND_UPDATE,
        payload,
        { headers: { Authorization: `Bearer ${token}` } },
      );

      const data = response.data;

      if (data.statusCode === 200) {
        toast.success(data.message, {
          position: "top-right",
          autoClose: 1500,
          theme: "colored",
        });
        fetchTutorOnboardingData();
        setInitialDescription(description);
        setCurrentStep((s) => Math.min(totalSteps, s + 1)); // Move to next step
      } else {
        // This will handle any 2xx response that is not 201
        showErrorToast(data.message);
      }
    } catch (error) {
      console.error("Error updating Description details:", error);
      // Server responded with non-2xx status (like 400, 500)

      // CHECK (expiry / invalid token)
      handleApiError(error, navigate, showErrorToast, "/signin");
    }
  };

  const handlePricingSubmit = async () => {
    if (!pricing.basePrice || pricing.basePrice <= 0) {
      showErrorToast("Please enter a valid course price.");
      return;
    }

    if (!pricing.bankInfo) {
      showErrorToast("Please fill out all the required fields.");
      return;
    }

    if (!/^[\w.-]{2,}@[a-zA-Z0-9.-]+$/.test(pricing.bankInfo)) {
      showErrorToast("Enter a valid UPI ID.");
      return;
    }

    const isPaymentTermsConfirmed =
      document.getElementById("paymentTerms").checked;
    if (!isPaymentTermsConfirmed) {
      showErrorToast("You must agree to the terms and conditions.");
      return;
    }

    const token = localStorage.getItem("token");

    if (!token) {
      navigate("/signin");
      return;
    }

    if (!tutorId || !demoVideoId) {
      showErrorToast("Tutor or demo video not found.");
      return;
    }

    const planType = pricing.paymentType === "royalty" ? "ROYALTY" : "ONE_TIME";

    // Reuse the earnings calculation already in your UI
    const royaltyPercentage =
      pricing.paymentType === "royalty"
        ? (pricing.basePrice * 0.7).toFixed(2)
        : "";

    const payload = {
      tutor_id: tutorId,
      demo_id: demoVideoId,
      plan_type: planType,
      royalty_percentage: royaltyPercentage,
      price: pricing.basePrice,
      upi_id: pricing.bankInfo,
    };

    try {
      const response = await axios.post(
        TUTOR_ONBOARDING_API.TUTOR_ONBOARDING_PRICING_ADD,
        payload,
        { headers: { Authorization: `Bearer ${token}` } },
      );

      const data = response.data;

      if (data.statusCode === 200) {
        toast.success(data.message || "Plan details updated successfully!", {
          position: "top-right",
          autoClose: 1500,
          theme: "colored",
        });
        fetchTutorOnboardingData();
        setInitialPricing(pricing);
        setCurrentStep((s) => Math.min(totalSteps, s + 1)); // Move to next step
      } else {
        // This will handle any 2xx response that is not 201
        showErrorToast(data.message || "Failed to update plan details.");
      }
    } catch (error) {
      console.error("Error updating plan details:", error);
      // Server responded with non-2xx status (like 400, 500)

      // CHECK (expiry / invalid token)
      handleApiError(error, navigate, showErrorToast, "/signin");
    }
  };

  // get all tutors data
  const fetchTutorOnboardingData = useCallback(async () => {
    const token = localStorage.getItem("token");
    const userId = localStorage.getItem("user_id");

    if (!token || !userId) {
      navigate("/signin");
      return;
    }

    try {
      const res = await axios.post(
        TUTOR_ONBOARDING_API.TUTOR_ONBOARDING_GET_BY_USER_ID,
        { user_id: userId },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );

      const data = res.data;

      if (data.statusCode === 200) {
        const tutor = data.tutor;

        // Set full name
        setTutorFullName(data.fullname || "");

        // reject_reason from API
        setRejectReason(data.reject_reason || null);

        // Set tutorId from API
        if (tutor.tutor_details && tutor.tutor_details.tutor_id) {
          setTutorId(tutor.tutor_details.tutor_id);
        }

        // About info
        if (tutor.tutor_details) {
          const td = tutor.tutor_details || {};
          const fetchedData = {
            firstName: td.full_name || "",
            // lastName: td.last_name || "",
            email: td.email || "",
            country: td.country || "",
            subject: td.subject_to_teach || "",
            language: td.speak_language || "",
            level: td.level || "",
            phone: td.phone_number || "",
          };

          setFormData(fetchedData);
          setInitialFormData(fetchedData);

          // Photo
          if (td.profile_pic_url) setUploadedPhoto(td.profile_pic_url);

          // Certificates
          if (tutor.certificates) {
            const fetchedCerts = (tutor.certificates || []).map((cert) => ({
              tutor_certificate_id: cert.tutor_certificate_id,
              name: cert.certificate_name || "",
              issuedBy: cert.issued_by || "",
              date: cert.date_of_issue
                ? cert.date_of_issue.split("T")[0] // <-- convert to YYYY-MM-DD
                : "",
              file: cert.certificate_file_url || "",
              certFileName: cert.certificate_file || "",
            }));
            setCertificates(fetchedCerts);
            setInitialCertificates(fetchedCerts);
          }

          // Education
          if (tutor.education) {
            const fetchedEdu = (tutor.education || []).map((edu) => ({
              tutor_education_id: edu.tutor_education_id,
              degree: edu.degree || "",
              institution: edu.institution || "",
              specialization: edu.specialization || "",
              yearOfGraduation: edu.year_of_passout || "",
            }));
            setEducations(fetchedEdu);
            setInitialEducations(fetchedEdu);
          }

          // Experience
          const fetchedExper = {
            yearsOfExperience: td.years_of_experience || "",
            professionalBackground: td.professional_background || "",
            achievements: td.achievements || "",
          };
          setExperience(fetchedExper);
          setInitialExperience(fetchedExper);
        }

        // Demo Video
        if (tutor.demo_video) {
          const dv = tutor.demo_video;
          const fetchedDemoData = {
            demo_video_id: dv.demo_video_id,
            videoTitle: dv.video_title || "",
            videoDescription: dv.video_description || "",
            status: dv.status || "",
          };
          setDemoVideoData(fetchedDemoData);
          setInitialDemoVideoData(fetchedDemoData);

          // Set tutorId from API
          setDemoVideoId(dv.demo_video_id);

          if (dv.video_file_url) {
            setDemoVideoFile(dv.video_file_url);
            setInitialDemoVideoFile(dv.video_file_url);
          }

          // Description
          const fetchedDescri = {
            shortBio: dv.short_bio || "",
            teachingStyle: dv.teaching_style || "",
            studentExpectations: dv.student_can_expect || "",
          };
          setDescription(fetchedDescri);
          setInitialDescription(fetchedDescri);

          //  Pricing
          if (tutor.payment_plan) {
            const pp = tutor.payment_plan;
            const fetchedPrice = {
              payment_plan_id: pp.payment_plan_id,
              demo_id: pp.demo_id,
              paymentType: pp.plan_type === "ROYALTY" ? "royalty" : "oneTime",
              basePrice: pp.price || "",
              bankInfo: pp.upi_id || "",
            };
            setPricing(fetchedPrice);
            setInitialPricing(fetchedPrice);
          }
        }

        const lastCompletedStep = getLastCompletedStep(tutor);

        // Move user to next incomplete step
        // setCurrentStep(lastCompletedStep + 1);
        setCurrentStep(Math.min(lastCompletedStep + 1, steps.length));
      } else {
        // This will handle any 2xx response that is not 201
        // showErrorToast(data.message);
      }
    } catch (err) {
      console.error("Error fetching tutor data:", err);
      // Server responded with non-2xx status (like 400, 500)

      // CHECK (expiry / invalid token)
      handleApiError(err, navigate, showErrorToast, "/signin");
    }
  }, [navigate]);

  useEffect(() => {
    fetchTutorOnboardingData();
  }, [fetchTutorOnboardingData]);

  // update api's
  const handleAboutUpdateSubmit = async (e) => {
    e.preventDefault();

    // Validation (same as before)
    if (!validateAboutForm()) return;

    const token = localStorage.getItem("token");

    if (!token) {
      navigate("/signin");
      return;
    }

    if (!tutorId) {
      showErrorToast("Tutor not found. Please save first.");
      return;
    }

    const payload = {
      tutor_id: tutorId,
      // first_name: formData.firstName,
      // last_name: formData.lastName,
      // email: formData.email,
      country: formData.country,
      subject_to_teach: formData.subject,
      speak_language: formData.language,
      // phone_number: formData.phone,
      level: formData.level,
    };

    try {
      const response = await axios.post(
        TUTOR_ONBOARDING_API.TUTOR_ONBOARDING_ABOUT_UPDATE,
        payload,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );

      const data = response.data;

      if (data.statusCode === 200) {
        toast.success(data.message, {
          position: "top-right",
          autoClose: 1500,
          theme: "colored",
        });
        fetchTutorOnboardingData();
        // Move to next step
        setCurrentStep((prevStep) => Math.min(totalSteps, prevStep + 1));
      } else {
        // This will handle any 2xx response that is not 201
        showErrorToast(data.message);
      }
    } catch (error) {
      console.error("Error updating tutor details:", error);
      // Server responded with non-2xx status (like 400, 500)

      // CHECK (expiry / invalid token)
      handleApiError(error, navigate, showErrorToast, "/signin");
    }
  };

  const handleCertificateUpdateSubmit = async () => {
    const token = localStorage.getItem("token");

    if (!token) {
      navigate("/signin");
      return;
    }

    if (!tutorId) {
      showErrorToast("Tutor not found. Please complete previous steps first.");
      return;
    }

    for (let i = 0; i < certificates.length; i++) {
      const cert = certificates[i];

      if (!cert.name || !cert.issuedBy || !cert.date) {
        showErrorToast(`Please complete all fields for Certificate ${i + 1}.`);
        return;
      }

      const today = new Date().toISOString().split("T")[0];
      if (cert.date > today) {
        showErrorToast(`Certificate ${i + 1} date cannot be in the future.`);
        return;
      }

      // Validate name
      if (!allowedRegex.test(cert.name)) {
        showErrorToast(
          `Certificate Name in Certificate ${i + 1} should contain only alphabets.`,
        );
        return;
      }

      // Validate name
      if (!allowedRegex.test(cert.issuedBy)) {
        showErrorToast(
          `Issued By in Certificate ${i + 1} should contain only alphabets.`,
        );
        return;
      }
    }

    // Check for duplicates
    const hasDuplicate = certificates.some((cert, i) =>
      certificates
        .slice(i + 1)
        .some(
          (c) =>
            c.name === cert.name &&
            c.issuedBy === cert.issuedBy &&
            c.date === cert.date,
        ),
    );
    if (hasDuplicate) {
      showErrorToast(
        "Duplicate certificates detected. Please remove duplicates.",
      );
      return;
    }

    const formData = new FormData();
    formData.append("tutor_id", tutorId);

    const certsMeta = certificates.map((cert, index) => {
      // Generate unique key for new certificates
      const fileKey =
        cert.tutor_certificate_id ||
        cert.fileKey ||
        `new_cert_${Date.now()}_${index}`;

      // Save key back to certificate state for later mapping
      cert.fileKey = fileKey;
      return {
        tutor_certificate_id: cert.tutor_certificate_id || null,
        certificate_name: cert.name,
        issued_by: cert.issuedBy,
        date_of_issue: new Date(cert.date).toISOString().split("T")[0],
        file_key: fileKey,
      };
    });

    formData.append("certificates", JSON.stringify(certsMeta));

    // Append files using their file_key
    certificates.forEach((cert) => {
      if (cert.file && typeof cert.file !== "string") {
        formData.append(cert.fileKey, cert.file); // backend reads file by key
      }
    });

    try {
      const response = await axios.post(
        TUTOR_ONBOARDING_API.TUTOR_ONBOARDING_CERTIFICATE_UPDATE,
        formData,
        { headers: { Authorization: `Bearer ${token}` } },
      );

      const data = response.data;

      if (data.statusCode === 200) {
        toast.success(data.message, {
          position: "top-right",
          autoClose: 1500,
          theme: "colored",
        });
        fetchTutorOnboardingData();
        setInitialCertificates(certificates); // reset initial after update
        setCurrentStep((prev) => Math.min(totalSteps, prev + 1));
      } else {
        // This will handle any 2xx response that is not 201
        showErrorToast(data.message);
      }
    } catch (error) {
      console.error("Error updating certificates:", error);
      // Server responded with non-2xx status (like 400, 500)

      // CHECK (expiry / invalid token)
      handleApiError(error, navigate, showErrorToast, "/signin");
    }
  };

  const handleEducationUpdateSubmit = async () => {
    const token = localStorage.getItem("token");

    if (!token) {
      navigate("/signin");
      return;
    }
    if (!tutorId) {
      showErrorToast("Tutor not found. Please complete previous steps first.");
      return;
    }

    const usedYears = new Set();
    for (let i = 0; i < educations.length; i++) {
      const edu = educations[i];
      if (
        !edu.degree ||
        !edu.institution ||
        !edu.specialization ||
        !edu.yearOfGraduation
      ) {
        showErrorToast(`Please complete all fields for Education ${i + 1}.`);
        return;
      }

      // Validate alphabetic fields
      if (!allowedRegex.test(edu.degree)) {
        showErrorToast(
          `Degree in Education ${i + 1} should contain only alphabets.`,
        );
        return;
      }

      // Validate alphabetic fields
      if (!allowedRegex.test(edu.institution)) {
        showErrorToast(
          `Institution in Education ${i + 1} should contain only alphabets.`,
        );
        return;
      }

      // Validate alphabetic fields
      if (!allowedRegex.test(edu.specialization)) {
        showErrorToast(
          `Specialization in Education ${i + 1} should contain only alphabets.`,
        );
        return;
      }

      // NEW: Check if year already used
      if (usedYears.has(edu.yearOfGraduation)) {
        showErrorToast(
          `Year of Graduation ${edu.yearOfGraduation} is already used. Please select a different year.`,
        );
        return;
      } else {
        usedYears.add(edu.yearOfGraduation);
      }
    }

    const payload = {
      tutor_id: tutorId,
      education: educations.map((edu) => ({
        tutor_education_id: edu.tutor_education_id || null,
        degree: edu.degree,
        institution: edu.institution,
        specialization: edu.specialization,
        year_of_passout: edu.yearOfGraduation,
      })),
    };

    try {
      const response = await axios.post(
        TUTOR_ONBOARDING_API.TUTOR_ONBOARDING_EDUCATION_UPDATE,
        payload,
        { headers: { Authorization: `Bearer ${token}` } },
      );

      const data = response.data;

      if (data.statusCode === 200) {
        toast.success(data.message, {
          position: "top-right",
          autoClose: 1500,
          theme: "colored",
        });
        fetchTutorOnboardingData();
        setInitialEducations(educations);
        setCurrentStep((s) => Math.min(totalSteps, s + 1));
      } else {
        // This will handle any 2xx response that is not 201
        showErrorToast(data.message);
      }
    } catch (error) {
      console.error("Error updating education:", error);
      // Server responded with non-2xx status (like 400, 500)

      // CHECK (expiry / invalid token)
      handleApiError(error, navigate, showErrorToast, "/signin");
    }
  };

  const handleDemoVideoUpdateSubmit = async () => {
    if (isDemoVideoSubmitting) return;

    if (!demoVideoData.videoTitle || !demoVideoData.videoDescription) {
      showErrorToast("Please fill out both video title and description.");
      return;
    }

    // Validate alphabetic fields
    if (!allowedRegex.test(demoVideoData.videoTitle)) {
      showErrorToast("Video title should contain only letters.");
      return;
    }

    // Minimum length validation for professionalBackground
    if (demoVideoData.videoDescription.length < 30) {
      showErrorToast("Video description must be at least 30 characters.");
      return;
    }

    if (!/[a-zA-Z]/.test(demoVideoData.videoDescription)) {
      showErrorToast("Description must include at least one letter.");
      return;
    }

    if (!demoVideoFile) {
      showErrorToast("Please upload a demo video.");
      return;
    }

    // const isDemoVideoAgeConfirmed =
    //   document.getElementById("ageConfirm").checked;
    // if (!isDemoVideoAgeConfirmed) {
    //   showErrorToast("You must confirm that you are 18 years of age.");
    //   return;
    // }

    const token = localStorage.getItem("token");

    if (!token) {
      navigate("/signin");
      return;
    }

    if (!tutorId) {
      showErrorToast("Tutor not found. Please complete previous steps first.");
      return;
    }

    setIsDemoVideoSubmitting(true);

    const formData = new FormData();
    formData.append("tutor_id", tutorId);
    formData.append("demo_video_id", demoVideoData.demo_video_id);
    formData.append("video_title", demoVideoData.videoTitle.trim());
    formData.append("video_description", demoVideoData.videoDescription.trim());
    if (demoVideoFile instanceof File) {
      formData.append("video_file", demoVideoFile);
    }

    try {
      const response = await axios.post(
        TUTOR_ONBOARDING_API.TUTOR_ONBOARDING_DEMO_VIDEO_UPDATE,
        formData,
        {
          headers: { Authorization: `Bearer ${token}` },
        },
      );

      const data = response.data;

      if (data.statusCode === 200) {
        toast.success(data.message, {
          position: "top-right",
          autoClose: 1500,
          theme: "colored",
        });
        fetchTutorOnboardingData();
        // Update initial state
        setInitialDemoVideoData(demoVideoData);
        setInitialDemoVideoFile(demoVideoFile);

        setCurrentStep((s) => Math.min(totalSteps, s + 1));
      } else {
        // This will handle any 2xx response that is not 201
        showErrorToast(data.message);
      }
    } catch (error) {
      console.error("Error updating demo video:", error);
      // Server responded with non-2xx status (like 400, 500)

      // CHECK (expiry / invalid token)
      handleApiError(error, navigate, showErrorToast, "/signin");
    } finally {
      setIsDemoVideoSubmitting(false);
    }
  };

  const handlePricingUpdateSubmit = async () => {
    if (!pricing.basePrice || pricing.basePrice <= 0) {
      showErrorToast("Please enter a valid course price.");
      return;
    }

    if (!/^[\w.-]{2,}@[a-zA-Z0-9.-]+$/.test(pricing.bankInfo)) {
      showErrorToast("Enter a valid UPI ID.");
      return;
    }

    if (!pricing.bankInfo) {
      showErrorToast("Please fill out all the required fields.");
      return;
    }

    const isPaymentTermsConfirmed =
      document.getElementById("paymentTerms").checked;
    if (!isPaymentTermsConfirmed) {
      showErrorToast("You must agree to the terms and conditions.");
      return;
    }

    const token = localStorage.getItem("token");

    if (!token) {
      navigate("/signin");
      return;
    }

    if (!tutorId || !demoVideoId) {
      showErrorToast("Tutor or demo video not found");
      return;
    }

    if (!pricing.payment_plan_id) {
      showErrorToast("Payment plan not found. Cannot update.");
      return;
    }

    const planType = pricing.paymentType === "royalty" ? "ROYALTY" : "ONE_TIME";

    // Calculate royalty percentage for Royalty-based plans
    const royaltyPercentage =
      pricing.paymentType === "royalty"
        ? (pricing.basePrice * 0.7).toFixed(2)
        : 0;

    const payload = {
      payment_plan_id: pricing.payment_plan_id,
      tutor_id: tutorId,
      demo_id: demoVideoId,
      plan_type: planType,
      price: pricing.basePrice,
      royalty_percentage: royaltyPercentage,
      upi_id: pricing.bankInfo,
    };

    try {
      const response = await axios.post(
        TUTOR_ONBOARDING_API.TUTOR_ONBOARDING_PRICING_UPDATE,
        payload,
        { headers: { Authorization: `Bearer ${token}` } },
      );

      const data = response.data;

      if (data.statusCode === 200) {
        toast.success(data.message, {
          position: "top-right",
          autoClose: 1500,
          theme: "colored",
        });

        fetchTutorOnboardingData(); // Refresh tutor onboarding data
        setInitialPricing(pricing); // Update initial pricing state
        setCurrentStep((s) => Math.min(totalSteps, s + 1)); // Move to next step
      } else {
        // This will handle any 2xx response that is not 201
        showErrorToast(data.message);
      }
    } catch (error) {
      console.error("Error updating payment plan:", error);
      // Server responded with non-2xx status (like 400, 500)
      
      // CHECK (expiry / invalid token)
      handleApiError(error, navigate, showErrorToast, "/signin");
    }
  };

  return (
    <>
      {/* Header */}
      <div className="tutor-onboarding-header-section">
        <Container>
          <Navbar className="tutor-onboarding-navbar">
            <Navbar.Brand>
              <img
                className="tutor-onboarding-logo"
                src={Logo}
                alt="Skill Edition Logo"
              />
            </Navbar.Brand>

            <Nav className="align-items-center">
              <Dropdown
                className="tutor-onboarding-profile-dropdown"
                align="end"
              >
                <Dropdown.Toggle
                  className="tutor-onboarding-profile-btn"
                  id="dropdown-basic"
                >
                  <div className="tutor-onboarding-profile-info">
                    <div className="tutor-onboarding-profile-icon">
                      {tutorFullName
                        ? tutorFullName
                            .split(" ")
                            .map((n) => n[0])
                            .join("")
                            .toUpperCase()
                        : "NA"}
                    </div>
                    <div className="tutor-onboarding-profile-text">
                      <span className="tutor-onboarding-profile-name">
                        {tutorFullName || "Tutor"}
                      </span>
                      <span className="tutor-onboarding-profile-role">
                        Tutor
                      </span>
                    </div>
                    <FaChevronDown className="tutor-onboarding-dropdown-arrow" />
                  </div>
                </Dropdown.Toggle>

                <Dropdown.Menu className="tutor-onboarding-profile-menu">
                  <Dropdown.Item onClick={handleLogout}>Logout</Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
            </Nav>
          </Navbar>

          {/* TITLE + PROGRESS */}
          <div className="tutor-onboarding-header-container">
            <h2 className="tutor-onboarding-header-title">
              <span>Tutor Onboarding</span>
              <span className="tutor-onboarding-header-badge">
                Step {currentStep} to {totalSteps}
              </span>
            </h2>
            <p className="tutor-onboarding-header-subtitle mb-3">
              Complete your profile to start teaching on Skilledition Step{" "}
              {currentStep} of {totalSteps}
            </p>
            <ProgressBar
              now={progressPercent}
              className="tutor-onboarding-progress-bar"
            />
          </div>

          {/* STEP NAVIGATION */}
          <div className="tutor-onboarding-navigation">
            {steps.map((step, index) => {
              const isActive = step.id === currentStep;
              const isCompleted = step.id < currentStep;

              // Icon logic
              const iconSrc = isCompleted
                ? completed
                : isActive
                  ? step.iconActive
                  : step.iconDefault;

              return (
                <div key={step.id} className="tutor-onboarding-item-wrapper">
                  <div
                    className={`tutor-onboarding-step-item ${
                      isActive ? "active" : ""
                    } ${isCompleted ? "completed" : ""}`}
                    // onClick={() => setCurrentStep(step.id)}
                  >
                    <div className="tutor-onboarding-step-icon">
                      <img src={iconSrc} alt={step.label} />
                    </div>
                    <div className="tutor-onboarding-step-label mt-3">
                      {step.label}
                    </div>
                  </div>

                  {/* Connector line except last */}
                  {index < steps.length - 1 && (
                    <div
                      className={`tutor-onboarding-step-connector ${
                        step.id < currentStep ? "connector-active" : ""
                      }`}
                    />
                  )}
                </div>
              );
            })}
          </div>
        </Container>
      </div>

      {/* About step*/}
      {currentStep === 1 && (
        <div className="tutor-onboarding-about-section">
          <Container>
            <Row>
              {/* LEFT SIDE — FORM */}
              <Col lg={8} md={12}>
                <div className="tutor-onboarding-about-form-container">
                  <h5 className="tutor-onboarding-about-title">
                    <FaUser className="tutor-onboarding-about-icon me-2" />
                    About You
                  </h5>
                  <Row className="g-3 mt-1">
                    <Col md={12}>
                      <label className="tutor-onboarding-about-form-label">
                        Full Name*
                      </label>
                      <input
                        type="text"
                        name="firstName"
                        className={`form-control ${
                          formData.firstName ? "filled" : ""
                        }`}
                        placeholder="Enter first name"
                        value={formData.firstName}
                        // onChange={handleChange}
                        readOnly
                      />
                    </Col>

                    {/* <Col md={6}>
                      <label className="tutor-onboarding-about-form-label">
                        Last Name*
                      </label>
                      <input
                        type="text"
                        name="lastName"
                        className={`form-control ${
                          formData.lastName ? "filled" : ""
                        }`}
                        placeholder="Enter last name"
                        value={formData.lastName}
                        onChange={handleChange}
                      />
                    </Col> */}

                    <Col md={12}>
                      <label className="tutor-onboarding-about-form-label">
                        Email*
                      </label>
                      <input
                        type="email"
                        name="email"
                        className={`form-control ${
                          formData.email ? "filled" : ""
                        }`}
                        placeholder="Enter email address"
                        value={formData.email}
                        // onChange={handleChange}
                        readOnly
                      />
                    </Col>

                    <Col md={6}>
                      <label className="tutor-onboarding-about-form-label">
                        Select Country*
                      </label>
                      <select
                        name="country"
                        className={`form-select ${
                          formData.country ? "filled" : ""
                        }`}
                        value={formData.country}
                        onChange={handleChange}
                      >
                        <option value="">Select Country</option>
                        <option value="India">India</option>
                      </select>
                    </Col>

                    <Col md={6}>
                      <label className="tutor-onboarding-about-form-label">
                        Subject to Teach*
                      </label>
                      <select
                        name="subject"
                        className={`form-select ${
                          formData.subject ? "filled" : ""
                        }`}
                        value={formData.subject}
                        onChange={handleChange}
                      >
                        <option value="">Select Subject</option>
                        <option value="HTML & CSS">HTML & CSS</option>
                        <option value="JavaScript">JavaScript</option>
                        <option value="React">React</option>
                        <option value="Node.js">Node.js</option>
                        <option value="Express.js">Express.js</option>
                        <option value="MongoDB">MongoDB</option>
                        <option value="MERN Stack Development">
                          MERN Stack Development
                        </option>
                      </select>
                    </Col>

                    <Col md={8}>
                      <label className="tutor-onboarding-about-form-label">
                        Language you speak*
                      </label>
                      <select
                        name="language"
                        className={`form-select ${formData.language ? "filled" : ""}`}
                        value={formData.language}
                        onChange={handleChange}
                      >
                        <option value="">Select language</option>
                        {indianLanguages.map((lang) => (
                          <option key={lang} value={lang}>
                            {lang}
                          </option>
                        ))}
                      </select>
                    </Col>

                    <Col md={4}>
                      <label className="tutor-onboarding-about-form-label">
                        &nbsp;
                      </label>
                      <select
                        name="level"
                        className={`form-select ${
                          formData.level ? "filled" : ""
                        }`}
                        value={formData.level}
                        onChange={handleChange}
                      >
                        <option value="">Select level</option>
                        <option value="Beginner">Beginner</option>
                        <option value="Intermediate">Intermediate</option>
                        <option value="Expert">Expert</option>
                      </select>
                    </Col>

                    <Col md={12}>
                      <label className="tutor-onboarding-about-form-label">
                        Phone Number*
                      </label>
                      <input
                        type="text"
                        name="phone"
                        className={`form-control ${
                          formData.phone ? "filled" : ""
                        }`}
                        placeholder="Enter mobile number"
                        value={formData.phone}
                        // onChange={handleChange}
                        readOnly
                      />
                    </Col>

                    <Col md={12}>
                      <div className="tutor-onboarding-about-confirm-box">
                        <input type="checkbox" id="confirmAge" required />
                        <label htmlFor="confirmAge" className="ms-2">
                          I am confirm that I am 18 years of age
                        </label>
                      </div>
                    </Col>
                  </Row>
                </div>
              </Col>

              {/* RIGHT SIDE — GETTING STARTED */}
              <Col lg={4} md={12}>
                <div className="tutor-onboarding-about-info-card">
                  <h6 className="tutor-onboarding-about-info-title">
                    <MdInfo className="tutor-onboarding-about-info-icon" />
                    Getting Started
                  </h6>
                  <p>
                    Welcome to Skilledition! Let’s start by learning more about
                    you. This information helps us match you with the right
                    students.
                  </p>
                  <ul>
                    <li>Use your legal name for verification</li>
                    <li>Choose your primary teaching subject</li>
                    <li>Add all languages you can teach in</li>
                  </ul>
                </div>
              </Col>
            </Row>

            {/* NAVIGATION BUTTONS */}
            <div
              className="tutor-onboarding-about-buttons"
              style={{
                justifyContent: "flex-end",
                gap: "10px",
                marginTop: "20px",
              }}
            >
              {/* <button
                className="tutor-onboarding-about-back-btn btn"
                onClick={() => setCurrentStep((s) => Math.max(1, s - 1))}
              >
                <FiChevronLeft size={15} /> Back
              </button> */}
              <button
                className="tutor-onboarding-about-save-btn btn"
                onClick={
                  isFormChanged()
                    ? tutorId
                      ? handleAboutUpdateSubmit
                      : handleAboutSubmit
                    : () =>
                        setCurrentStep((prevStep) =>
                          Math.min(totalSteps, prevStep + 1),
                        ) // If no changes, just
                }
              >
                {
                  tutorId && isFormChanged()
                    ? "Update & Continue" // Show "Update & Continue" if tutorId exists and form data is changed
                    : !tutorId && isFormChanged()
                      ? "Save & Continue" // Show "Save & Continue" if tutorId doesn't exist and form data is changed
                      : "Continue" // If no changes, show "Continue"
                }
              </button>
            </div>
          </Container>
        </div>
      )}

      {/* Photo step */}
      {currentStep === 2 && (
        <div className="tutor-onboarding-photo-section">
          <Container>
            <Row>
              {/* LEFT SIDE — Upload Box */}
              <Col lg={8} md={12}>
                <div className="tutor-onboarding-photo-upload-box text-center">
                  <h5 className="tutor-onboarding-about-title mb-4">
                    <FaFileArrowUp className="tutor-onboarding-about-icon me-2" />
                    Photo
                  </h5>

                  <input
                    type="file"
                    ref={fileInputRef}
                    accept="image/*"
                    onChange={handlePhotoUpload}
                    style={{ display: "none" }}
                  />

                  {!uploadedPhoto ? (
                    <div className="tutor-onboarding-photo-upload-inner">
                      <div className="mb-3">
                        <FaFileArrowUp
                          size={30}
                          className="tutor-onboarding-photo-upload-icon"
                        />
                      </div>
                      <h6 className="tutor-onboarding-photo-upload-title">
                        Upload Profile Photo
                      </h6>
                      <p className="tutor-onboarding-photo-upload-text">
                        Complete your profile to start teaching on Skilledition
                        Step 2 of 9
                      </p>

                      <button
                        className="tutor-onboarding-photo-upload-btn"
                        onClick={() => fileInputRef.current?.click()}
                      >
                        Browse Files
                      </button>
                    </div>
                  ) : (
                    <div className="tutor-onboarding-photo-preview">
                      <img
                        src={uploadedPhoto}
                        alt="Profile Preview"
                        className="tutor-onboarding-photo-img"
                      />
                      <button
                        className="tutor-onboarding-photo-remove-btn btn"
                        onClick={handleReplacePhoto}
                      >
                        Replace Photo
                      </button>
                    </div>
                  )}

                  {/* PHOTO GUIDELINES */}
                  <div className="tutor-onboarding-photo-guidelines mt-4">
                    <h6 className="tutor-onboarding-photo-guidelines-title">
                      <MdInfo className="tutor-onboarding-photo-guidelines-icon me-1" />
                      Photo Guidelines:
                    </h6>
                    <ul>
                      <li>Use a clear, recent photo with good lighting</li>
                      <li>Face should be clearly visible</li>
                      <li>Professional attire recommended</li>
                      <li>No filters or heavy editing</li>
                      <li>Accepted formats: JPG, PNG (max 5MB)</li>
                    </ul>
                  </div>
                </div>
              </Col>

              {/* RIGHT SIDE — WHY PHOTO CARD */}
              <Col lg={4} md={12}>
                <div className="tutor-onboarding-photo-info-card">
                  <h6 className="tutor-onboarding-photo-info-title">
                    <MdInfo className="tutor-onboarding-about-info-icon" />
                    Why a profile photo?
                  </h6>
                  <p className="ps-4">
                    A professional photo helps build trust with students and
                    makes your profile more engaging.
                  </p>
                  <ul className="tutor-onboarding-photo-info-ul">
                    <li>Increases profile views by 40%</li>
                    <li>Builds student confidence</li>
                    <li>Creates personal connection</li>
                  </ul>
                </div>
              </Col>
            </Row>

            {/* NAVIGATION BUTTONS */}
            <div className="tutor-onboarding-about-buttons">
              <button
                className="tutor-onboarding-about-back-btn btn"
                onClick={() => setCurrentStep((s) => Math.max(1, s - 1))}
              >
                <FiChevronLeft size={15} /> Back
              </button>
              <button
                className="tutor-onboarding-about-save-btn btn"
                onClick={
                  () =>
                    !uploadedPhoto && !photoFile
                      ? showErrorToast(
                          "Please upload a photo before continuing.",
                        ) // No photo anywhere
                      : photoFile
                        ? handlePhotoAddOrUpdate() // New photo uploaded
                        : setCurrentStep((prevStep) =>
                            Math.min(totalSteps, prevStep + 1),
                          ) // Existing photo
                }
              >
                {!uploadedPhoto && !photoFile
                  ? "Save & Continue"
                  : photoFile
                    ? "Save & Continue"
                    : "Continue"}
              </button>
            </div>
          </Container>
        </div>
      )}

      {/* Certificate step */}
      {currentStep === 3 && (
        <div className="tutor-onboarding-about-section">
          <Container>
            <Row className="justify-content-center">
              <Col lg={10} md={12}>
                <div className="tutor-onboarding-about-form-container">
                  {certificates.length > 0 && (
                    <h5 className="tutor-onboarding-about-title">
                      <FaUser className="tutor-onboarding-about-icon me-2" />
                      Certificates
                    </h5>
                  )}

                  {/* Certificate  */}
                  {certificates.length === 0 ? (
                    // Initial state: no certificates
                    <div className="tutor-onboarding-no-certifications mt-4">
                      <FaUser className="tutor-onboarding-no-certifications-icon" />
                      <p className="tutor-onboarding-no-certifications-para mb-1">
                        No certifications added yet
                      </p>
                      <p className="tutor-onboarding-no-certifications-para">
                        Click the button below to add your first certification
                      </p>
                    </div>
                  ) : (
                    certificates.map((cert, index) => (
                      <div
                        className="tutor-onboarding-certificate-box mt-4"
                        key={cert.tutor_certificate_id || `new-cert-${index}`}
                      >
                        <div className="tutor-onboarding-certificate-header">
                          <h6 className="tutor-onboarding-certificate-header-title">
                            Certificate {index + 1}
                          </h6>
                          {!cert.tutor_certificate_id && (
                            <button
                              className="tutor-onboarding-certificate-remove-btn"
                              onClick={() => {
                                const newCerts = certificates.filter(
                                  (_, i) => i !== index,
                                );
                                setCertificates(newCerts);
                              }}
                            >
                              ✕
                            </button>
                          )}
                        </div>

                        <Row className="g-3 mt-1">
                          <Col md={6}>
                            <label className="tutor-onboarding-about-form-label">
                              Certificate Name
                            </label>
                            <input
                              type="text"
                              name="name"
                              className={`form-control ${
                                cert.name ? "filled" : ""
                              }`}
                              placeholder="Enter certificate name"
                              value={cert.name}
                              onChange={(e) =>
                                handleCertificateChange(index, e)
                              }
                            />
                          </Col>

                          <Col md={6}>
                            <label className="tutor-onboarding-about-form-label">
                              Issued By
                            </label>
                            <input
                              type="text"
                              name="issuedBy"
                              className={`form-control ${
                                cert.issuedBy ? "filled" : ""
                              }`}
                              placeholder="Enter issuing authority"
                              value={cert.issuedBy}
                              onChange={(e) =>
                                handleCertificateChange(index, e)
                              }
                            />
                          </Col>

                          <Col md={6}>
                            <label className="tutor-onboarding-about-form-label">
                              Date of Issue
                            </label>
                            <input
                              type="date"
                              name="date"
                              className={`form-control ${
                                cert.date ? "filled" : ""
                              }`}
                              value={cert.date}
                              onChange={(e) =>
                                handleCertificateChange(index, e)
                              }
                            />
                          </Col>

                          <Col md={6}>
                            <label className="tutor-onboarding-about-form-label">
                              Upload Certificate (PDF / PNG)
                            </label>
                            <input
                              type="file"
                              name="file"
                              className={`form-control ${
                                cert.file ? "filled" : ""
                              }`}
                              accept=".pdf,.png,.jpg,.jpeg"
                              onChange={(e) =>
                                handleCertificateChange(index, e)
                              }
                            />
                            {/* Display filename if file exists */}
                            {cert.file && (
                              <p className="tutor-onboarding-about-form-label mt-2">
                                File uploaded:{" "}
                                {typeof cert.file === "string"
                                  ? cert.certFileName
                                      .split("/")
                                      .pop()
                                      .split("_")
                                      .slice(1)
                                      .join("_")
                                  : cert.file.name}
                              </p>
                            )}
                          </Col>
                        </Row>
                      </div>
                    ))
                  )}
                </div>

                {/* Add New Certificate Button */}
                <button
                  className="tutor-onboarding-add-certificate-btn mt-3"
                  onClick={() =>
                    setCertificates([
                      ...certificates,
                      { name: "", issuedBy: "", date: "", file: null },
                    ])
                  }
                >
                  {certificates.length === 0
                    ? "+ Add Certification"
                    : "+ Add Another Certification"}
                </button>
              </Col>
            </Row>

            {/* NAVIGATION BUTTONS */}
            <Row className="justify-content-center">
              <Col lg={10} md={12}>
                <div className="tutor-onboarding-about-buttons">
                  <button
                    className="tutor-onboarding-about-back-btn btn"
                    onClick={() => setCurrentStep((s) => Math.max(1, s - 1))}
                  >
                    <FiChevronLeft size={15} /> Back
                  </button>
                  <button
                    className="tutor-onboarding-about-save-btn btn"
                    disabled={certificates.length === 0}
                    onClick={
                      () =>
                        certificates.length === 0
                          ? showErrorToast(
                              "Please add at least one certificate before continuing.",
                            )
                          : isCertificatesChanged()
                            ? initialCertificates.length === 0
                              ? handleCertificateSubmit() // first time adding
                              : handleCertificateUpdateSubmit() // existing certificates, updated
                            : setCurrentStep((prev) =>
                                Math.min(totalSteps, prev + 1),
                              ) // no changes
                    }
                  >
                    {certificates.length === 0
                      ? "Add Certificate" // or "Add Certificate" for clarity
                      : initialCertificates.length === 0
                        ? "Save & Continue"
                        : isCertificatesChanged()
                          ? "Update & Continue"
                          : "Continue"}
                  </button>
                </div>
              </Col>
            </Row>
          </Container>
        </div>
      )}

      {/* Education step */}
      {currentStep === 4 && (
        <div className="tutor-onboarding-about-section">
          <Container>
            <Row className="justify-content-center">
              <Col lg={10} md={12}>
                <div className="tutor-onboarding-about-form-container">
                  {educations.length > 0 && (
                    <h5 className="tutor-onboarding-about-title">
                      <FaUser className="tutor-onboarding-about-icon me-2" />
                      Education
                    </h5>
                  )}

                  {/* Education Section */}
                  {educations.length === 0 ? (
                    // Initial state: no education entries
                    <div className="tutor-onboarding-no-certifications mt-4">
                      <FaUser className="tutor-onboarding-no-certifications-icon" />
                      <p className="tutor-onboarding-no-certifications-para mb-1">
                        No Education added yet
                      </p>
                      <p className="tutor-onboarding-no-certifications-para">
                        Click the button below to add your first education
                      </p>
                    </div>
                  ) : (
                    educations.map((education, index) => (
                      <div
                        className="tutor-onboarding-certificate-box mt-4"
                        key={education.tutor_education_id || `new-edu-${index}`}
                      >
                        <div className="tutor-onboarding-certificate-header">
                          <h6 className="tutor-onboarding-certificate-header-title">
                            Education {index + 1}
                          </h6>
                          {!education.tutor_education_id && (
                            <button
                              className="tutor-onboarding-certificate-remove-btn"
                              onClick={() => {
                                const newEducations = educations.filter(
                                  (_, i) => i !== index,
                                );
                                setEducations(newEducations);
                              }}
                            >
                              ✕
                            </button>
                          )}
                        </div>

                        <Row className="g-3 mt-1">
                          <Col md={6}>
                            <label className="tutor-onboarding-about-form-label">
                              Degree
                            </label>
                            <input
                              type="text"
                              name="degree"
                              className={`form-control ${
                                education.degree ? "filled" : ""
                              }`}
                              placeholder="e.g., bachelor of science"
                              value={education.degree}
                              onChange={(e) => handleEducationChange(index, e)}
                            />
                          </Col>

                          <Col md={6}>
                            <label className="tutor-onboarding-about-form-label">
                              Institution
                            </label>
                            <input
                              type="text"
                              name="institution"
                              className={`form-control ${
                                education.institution ? "filled" : ""
                              }`}
                              placeholder="e.g., krishna university"
                              value={education.institution}
                              onChange={(e) => handleEducationChange(index, e)}
                            />
                          </Col>

                          <Col md={6}>
                            <label className="tutor-onboarding-about-form-label">
                              Specialization
                            </label>
                            <input
                              type="text"
                              name="specialization"
                              className={`form-control ${
                                education.specialization ? "filled" : ""
                              }`}
                              placeholder="e.g., computer science"
                              value={education.specialization}
                              onChange={(e) => handleEducationChange(index, e)}
                            />
                          </Col>

                          <Col md={6}>
                            <label className="tutor-onboarding-about-form-label">
                              Year of Graduation
                            </label>

                            <select
                              name="yearOfGraduation"
                              className={`form-select ${education.yearOfGraduation ? "filled" : ""}`}
                              value={education.yearOfGraduation}
                              onChange={(e) => handleEducationChange(index, e)}
                            >
                              <option value="">Select Year</option>
                              {Array.from(
                                { length: 2030 - 1990 + 1 },
                                (_, i) => {
                                  const year = 1990 + i;
                                  return (
                                    <option key={year} value={year}>
                                      {year}
                                    </option>
                                  );
                                },
                              )}
                            </select>
                          </Col>
                        </Row>
                      </div>
                    ))
                  )}
                </div>

                {/* Add New Education Button */}
                <button
                  className="tutor-onboarding-add-certificate-btn mt-3"
                  onClick={() =>
                    setEducations([
                      ...educations,
                      {
                        degree: "",
                        institution: "",
                        specialization: "",
                        yearOfGraduation: "",
                      },
                    ])
                  }
                >
                  {educations.length === 0
                    ? "+ Add Education"
                    : "+ Add Another Education"}
                </button>
              </Col>
            </Row>

            {/* NAVIGATION BUTTONS */}
            <Row className="justify-content-center">
              <Col lg={10} md={12}>
                <div className="tutor-onboarding-about-buttons">
                  <button
                    className="tutor-onboarding-about-back-btn btn"
                    onClick={() => setCurrentStep((s) => Math.max(1, s - 1))}
                  >
                    <FiChevronLeft size={15} /> Back
                  </button>
                  <button
                    className="tutor-onboarding-about-save-btn btn"
                    disabled={educations.length === 0}
                    onClick={
                      () =>
                        educations.length === 0
                          ? showErrorToast(
                              "Please add at least one education before continuing.",
                            )
                          : isEducationsChanged()
                            ? initialEducations.length === 0
                              ? handleEducationSubmit() // first time adding
                              : handleEducationUpdateSubmit() // existing educations updated
                            : setCurrentStep((prev) =>
                                Math.min(totalSteps, prev + 1),
                              ) // no changes
                    }
                  >
                    {educations.length === 0
                      ? "Add Education"
                      : initialEducations.length === 0
                        ? "Save & Continue"
                        : isEducationsChanged()
                          ? "Update & Continue"
                          : "Continue"}
                  </button>
                </div>
              </Col>
            </Row>
          </Container>
        </div>
      )}

      {/* Experience step */}
      {currentStep === 5 && (
        <div className="tutor-onboarding-about-section">
          <Container>
            <Row className="justify-content-center">
              <Col lg={10} md={12}>
                <div className="tutor-onboarding-about-form-container">
                  <h5 className="tutor-onboarding-about-title">
                    <FaUser className="tutor-onboarding-about-icon me-2" />
                    Professional Experience
                  </h5>

                  <Row className="g-3 mt-1">
                    {/* Years of Experience */}
                    <Col md={12}>
                      <label className="tutor-onboarding-about-form-label">
                        Years of Experience*
                      </label>
                      <select
                        name="yearsOfExperience"
                        className={`form-select ${
                          experience.yearsOfExperience ? "filled" : ""
                        }`}
                        value={experience.yearsOfExperience}
                        onChange={handleExperienceChange}
                      >
                        <option value="">Select years of experience</option>
                        {[
                          "0-2 Years",
                          "2-4 Years",
                          "5-7 Years",
                          "7-9 Years",
                          "10+ Years",
                        ].map((exp) => (
                          <option key={exp} value={exp}>
                            {exp}
                          </option>
                        ))}
                      </select>
                    </Col>

                    {/* Professional Background */}
                    <Col md={12}>
                      <label className="tutor-onboarding-about-form-label">
                        Professional Background / Expertise*
                      </label>
                      <textarea
                        name="professionalBackground"
                        className={`form-control ${
                          experience.professionalBackground ? "filled" : ""
                        }`}
                        placeholder="Describe your professional journey, key skills, and areas of expertise..."
                        value={experience.professionalBackground}
                        onChange={handleExperienceChange}
                        rows="4"
                      />
                    </Col>

                    {/* Achievements */}
                    <Col md={12}>
                      <label className="tutor-onboarding-about-form-label">
                        Achievements / Notable Work (Optional)
                      </label>
                      <textarea
                        name="achievements"
                        className={`form-control ${
                          experience.achievements ? "filled" : ""
                        }`}
                        placeholder="Share your key achievements, awards, projects, or notable contributions..."
                        value={experience.achievements}
                        onChange={handleExperienceChange}
                        rows="4"
                      />
                    </Col>

                    <Col md={12}>
                      <div className="tutor-onboarding-about-confirm-box">
                        <p className="tutor-onboarding-experience-info-para">
                          <b>Tip:</b> highlight specific achievements,
                          technologies you've mastered, and any unique
                          experiences that set you apart as an educator.
                        </p>
                      </div>
                    </Col>
                  </Row>
                </div>
              </Col>
            </Row>

            {/* NAVIGATION BUTTONS */}
            <Row className="justify-content-center">
              <Col lg={10} md={12}>
                <div className="tutor-onboarding-about-buttons">
                  <button
                    className="tutor-onboarding-about-back-btn btn"
                    onClick={() => setCurrentStep((s) => Math.max(1, s - 1))}
                  >
                    <FiChevronLeft size={15} /> Back
                  </button>
                  <button
                    className="tutor-onboarding-about-save-btn btn"
                    onClick={() =>
                      !experience.yearsOfExperience ||
                      !experience.professionalBackground
                        ? showErrorToast(
                            "Please fill out all required fields before continuing.",
                          )
                        : isExperienceChanged()
                          ? handleExperienceAddOrUpdate() // Only called on click
                          : setCurrentStep((prevStep) =>
                              Math.min(totalSteps, prevStep + 1),
                            )
                    }
                  >
                    {!experience.yearsOfExperience ||
                    !experience.professionalBackground
                      ? "Save & Continue"
                      : isExperienceChanged()
                        ? "Save & Continue"
                        : "Continue"}
                  </button>
                </div>
              </Col>
            </Row>
          </Container>
        </div>
      )}

      {/* Demo Video step */}
      {currentStep === 6 && (
        <div className="tutor-onboarding-photo-section">
          <Container>
            <Row>
              {/* LEFT SIDE — Upload & Form */}
              <Col lg={8} md={12}>
                <div className="tutor-onboarding-about-form-container">
                  <h5 className="tutor-onboarding-about-title mb-4">
                    <FaVideo className="tutor-onboarding-about-icon me-2" />
                    Demo Video Upload
                  </h5>

                  {/* Upload Box */}
                  <div
                    className="tutor-onboarding-photo-upload-inner text-center"
                    onDragOver={(e) => e.preventDefault()}
                    onDrop={(e) => {
                      e.preventDefault();
                      if (e.dataTransfer.files.length > 0) {
                        handleDemoVideoFile(e.dataTransfer.files[0]);
                      }
                    }}
                  >
                    <div className="mb-2">
                      <FaVideo
                        size={30}
                        className="tutor-onboarding-photo-upload-icon"
                        style={{ color: demoVideoFile ? "#00BA00" : undefined }}
                      />
                    </div>

                    {!demoVideoFile ? (
                      <>
                        <h6 className="tutor-onboarding-photo-upload-title">
                          Upload Demo Video
                        </h6>
                        <p className="tutor-onboarding-photo-upload-text">
                          Drag and drop your video here, or click to browse
                        </p>

                        <button
                          type="button"
                          className="tutor-onboarding-photo-upload-btn"
                          onClick={() =>
                            document.getElementById("demoVideoUpload").click()
                          }
                        >
                          Browse Files
                        </button>
                      </>
                    ) : (
                      <div>
                        <p className="tutor-onboarding-demo-video-para mt-0">
                          Video uploaded:{" "}
                          {demoVideoFile.name ||
                            (typeof demoVideoFile === "string"
                              ? demoVideoFile.split("/").pop().split("?")[0]
                              : "No video uploaded")}
                        </p>
                        {/* <div>
                          <p
                            className={`tutor-onboarding-demo-admin-review ${
                              demoVideoData.status === "reject"
                                ? "reject"
                                : "pending"
                            }`}
                          >
                            {demoVideoData.status === "reject"
                              ? "Rejected"
                              : "Pending Admin Review"}
                          </p>
                        </div> */}
                        <button
                          className="tutor-onboarding-photo-remove-btn btn mt-0"
                          onClick={(e) => {
                            e.stopPropagation();
                            handleRemoveDemoVideo();
                          }}
                        >
                          Remove Video
                        </button>
                      </div>
                    )}

                    <input
                      type="file"
                      id="demoVideoUpload"
                      accept="video/mp4,video/mov"
                      style={{ display: "none" }}
                      onChange={(e) => handleDemoVideoFile(e.target.files[0])}
                    />
                  </div>

                  <Row className="g-3 mt-1">
                    <Col md={12}>
                      {/* Video Title */}
                      <label className="tutor-onboarding-about-form-label">
                        Video Title *
                      </label>
                      <input
                        id="videoTitle"
                        type="text"
                        name="videoTitle"
                        className={`form-control ${
                          demoVideoData.videoTitle ? "filled" : ""
                        }`}
                        placeholder="e.g., Introduction to web development"
                        value={demoVideoData.videoTitle}
                        onChange={handleDemoVideoChange}
                      />
                    </Col>

                    {/* Video Description */}
                    <Col md={12}>
                      <label className="tutor-onboarding-about-form-label">
                        Video Description *
                      </label>
                      <textarea
                        id="videoDescription"
                        name="videoDescription"
                        className={`form-control ${
                          demoVideoData.videoDescription ? "filled" : ""
                        }`}
                        placeholder="Briefly describe what you cover in this demo video..."
                        rows={3}
                        value={demoVideoData.videoDescription}
                        onChange={handleDemoVideoChange}
                      />
                    </Col>

                    {/* Confirm Checkbox */}
                    {/* <Col md={12}>
                      <div className="tutor-onboarding-about-confirm-box">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          id="ageConfirm"
                          required
                        />
                        <label
                          className="form-check-label ms-2"
                          htmlFor="ageConfirm"
                        >
                          I am confirm that I am 18 years of age
                        </label>
                      </div>
                    </Col> */}
                  </Row>
                </div>
              </Col>

              {/* RIGHT SIDE — Demo Video Guidelines */}
              <Col lg={4} md={12}>
                <div className="tutor-onboarding-photo-info-card">
                  <h6 className="tutor-onboarding-photo-info-title">
                    Demo Video Guidelines
                  </h6>
                  <b>Duration:</b>
                  <p>3-5 minutes recommended</p>
                  <b>Content:</b>
                  <p>Introduce yourself and demonstrate your teaching</p>
                  <b>Quality:</b>
                  <p>Clear audio and good lighting</p>
                  <b>Format:</b>
                  <p>MP4, MOV (max 500MB)</p>

                  <div className="tutor-onboarding-demo-video-ul">
                    <b className="ps-3">Tips for Success:</b>
                    <ul className="mt-2">
                      <li className="tutor-onboarding-demo-video-li">
                        Smile and be enthusiastic
                      </li>
                      <li className="tutor-onboarding-demo-video-li">
                        Show your teaching approach
                      </li>
                      <li className="tutor-onboarding-demo-video-li">
                        Keep it concise and engaging
                      </li>
                    </ul>
                  </div>
                </div>
              </Col>
            </Row>

            {/* NAVIGATION BUTTONS */}
            <div className="tutor-onboarding-about-buttons">
              <button
                className="tutor-onboarding-about-back-btn btn"
                onClick={() => setCurrentStep((s) => Math.max(1, s - 1))}
              >
                <FiChevronLeft size={15} /> Back
              </button>
              <button
                className="tutor-onboarding-about-save-btn btn"
                disabled={isDemoVideoSubmitting}
                onClick={() =>
                  !demoVideoFile
                    ? showErrorToast(
                        "Please upload a demo video before continuing.",
                      )
                    : isDemoVideoChanged()
                      ? !initialDemoVideoData?.demo_video_id
                        ? handleDemoVideoSubmit() // FIRST TIME (ADD)
                        : handleDemoVideoUpdateSubmit() // UPDATE
                      : setCurrentStep((prev) => Math.min(totalSteps, prev + 1))
                }
              >
                {isDemoVideoSubmitting
                  ? "Saving..."
                  : !demoVideoFile
                    ? "Add Demo Video"
                    : !initialDemoVideoData?.demo_video_id
                      ? "Save & Continue"
                      : isDemoVideoChanged()
                        ? "Update & Continue"
                        : "Continue"}
              </button>
            </div>
          </Container>
        </div>
      )}

      {/* Description & Teaching step */}
      {currentStep === 7 && (
        <div className="tutor-onboarding-about-section">
          <Container>
            <Row>
              {/* LEFT SIDE — FORM */}
              <Col lg={8} md={12}>
                <div className="tutor-onboarding-about-form-container">
                  <h5 className="tutor-onboarding-about-title">
                    <FaFile className="tutor-onboarding-about-icon me-2" />
                    Description & Teaching Style
                  </h5>

                  <Row className="g-3 mt-1">
                    {/* Short Bio */}
                    <Col md={12}>
                      <label className="tutor-onboarding-about-form-label">
                        Short Bio*
                      </label>
                      <textarea
                        name="shortBio"
                        className={`form-control ${
                          description.shortBio ? "filled" : ""
                        }`}
                        placeholder="Write a compelling bio that students will see on your profile..."
                        rows={4}
                        maxLength={250}
                        value={description.shortBio}
                        onChange={handleDescriptionChange}
                      />
                      <small
                        className="text-muted"
                        style={{ fontSize: "12px" }}
                      >
                        {description.shortBio.length} / 250 characters
                      </small>
                    </Col>

                    {/* Teaching Style */}
                    <Col md={12}>
                      <label className="tutor-onboarding-about-form-label">
                        Teaching Style *
                      </label>
                      <div className="tutor-onboarding-description-style-options">
                        {[
                          "Practical",
                          "Interactive",
                          "Theoretical",
                          "Project-Based",
                          "Hands-On",
                        ].map((style) => (
                          <button
                            key={style}
                            type="button"
                            className={`tutor-onboarding-description-style-btn ${
                              description.teachingStyle === style
                                ? "active"
                                : ""
                            }`}
                            onClick={() =>
                              setDescription((prev) => ({
                                ...prev,
                                teachingStyle: style,
                              }))
                            }
                          >
                            {style}
                          </button>
                        ))}
                      </div>
                    </Col>

                    {/* What Students Can Expect */}
                    <Col md={12}>
                      <label className="tutor-onboarding-about-form-label">
                        What Students Can Expect *
                      </label>
                      <textarea
                        name="studentExpectations"
                        className={`form-control ${
                          description.studentExpectations ? "filled" : ""
                        }`}
                        placeholder="Describe what students will gain from your courses..."
                        rows={3}
                        value={description.studentExpectations}
                        onChange={handleDescriptionChange}
                      />
                    </Col>
                  </Row>
                </div>
              </Col>

              {/* RIGHT SIDE — Live Preview */}
              <Col lg={4} md={12}>
                <div className="tutor-onboarding-photo-info-card">
                  <h6 className="tutor-onboarding-photo-info-title mb-4">
                    Live Profile Preview
                  </h6>
                  <div className="tutor-onboarding-demo-video-ul px-3">
                    <div className="d-flex align-items-center mb-2">
                      <img
                        src={uploadedPhoto}
                        alt="Profile"
                        className="rounded-circle me-2"
                        width={35}
                        height={35}
                      />
                      <div>
                        <b>{formData.firstName}</b>
                      </div>
                    </div>

                    <p className="tutor-onboarding-description-right-side">
                      Bio
                      <br />
                      <span>
                        {description.shortBio ||
                          "Write a compelling bio that students will see on your profile..."}
                      </span>
                    </p>

                    <p className="tutor-onboarding-description-right-side mb-3">
                      Teaching Style
                    </p>
                    <span className="tutor-onboarding-description-span">
                      {description.teachingStyle || "Not selected"}
                    </span>
                  </div>
                </div>
              </Col>
            </Row>

            {/* NAVIGATION BUTTONS */}
            <div className="tutor-onboarding-about-buttons">
              <button
                className="tutor-onboarding-about-back-btn btn"
                onClick={() => setCurrentStep((s) => Math.max(1, s - 1))}
              >
                <FiChevronLeft size={15} /> Back
              </button>
              <button
                className="tutor-onboarding-about-save-btn btn"
                onClick={() =>
                  !description.shortBio ||
                  !description.teachingStyle ||
                  !description.studentExpectations
                    ? showErrorToast("Please fill out all the required fields.")
                    : isDescriptionChanged()
                      ? handleDescriptionAddOrUpdate() // Only call API if changes
                      : setCurrentStep((prevStep) =>
                          Math.min(totalSteps, prevStep + 1),
                        )
                }
              >
                {!description.shortBio ||
                !description.teachingStyle ||
                !description.studentExpectations
                  ? "Save & Continue"
                  : isDescriptionChanged()
                    ? "Save & Continue"
                    : "Continue"}
              </button>
            </div>
          </Container>
        </div>
      )}

      {/* Pricing & Payment step */}
      {currentStep === 8 && (
        <div className="tutor-onboarding-about-section">
          <Container>
            <Row className="justify-content-center">
              <Col lg={10} md={12}>
                <div className="tutor-onboarding-about-form-container">
                  <h5 className="tutor-onboarding-about-title">
                    <FaUser className="tutor-onboarding-about-icon me-2" />
                    Pricing & Payment
                  </h5>

                  {/* Payment Type Selection */}
                  <div className="tutor-onboarding-payment-type mt-4">
                    {[
                      {
                        key: "oneTime",
                        title: "One-Time Settlement",
                        desc: "Receive a fixed payout for each course created. Best for one-off course creation.",
                      },
                      {
                        key: "royalty",
                        title: "Royalty-Based",
                        desc: "Earn per student enrollment. Ongoing revenue as more students join your courses.",
                      },
                    ].map((opt) => (
                      <div
                        key={opt.key}
                        className={`tutor-onboarding-payment-box ${
                          pricing.paymentType === opt.key ? "active" : ""
                        }`}
                        onClick={() =>
                          setPricing((prev) => ({
                            ...prev,
                            paymentType: opt.key,
                          }))
                        }
                      >
                        <div className="tutor-onboarding-payment-header">
                          <img
                            src={bgPricingIcon}
                            alt="pricing icon"
                            className="tutor-onboarding-payment-img"
                          />
                          <h6 className="tutor-onboarding-payment-title mb-0">
                            {opt.title}
                          </h6>
                        </div>
                        <p className="tutor-onboarding-payment-desc mb-0">
                          {opt.desc}
                        </p>
                      </div>
                    ))}
                  </div>

                  {/* Price & Bank Details */}
                  <Row className="g-3 mt-3">
                    <Col md={6}>
                      <label className="tutor-onboarding-about-form-label">
                        Base Course Price (USD) *
                      </label>
                      <input
                        type="number"
                        name="basePrice"
                        className={`form-control mb-2 ${
                          pricing.basePrice ? "filled" : ""
                        }`}
                        placeholder="e.g., 49.99"
                        value={pricing.basePrice}
                        onChange={handlePricingChange}
                      />
                      <small className="tutor-onboarding-payment-small">
                        {pricing.paymentType === "royalty"
                          ? "Price per student enrollment (you earn 70%)"
                          : "Your fixed payout per course"}
                      </small>
                    </Col>

                    <Col md={6}>
                      <label className="tutor-onboarding-about-form-label">
                        Bank/UPI Information *
                      </label>
                      <input
                        type="text"
                        name="bankInfo"
                        className={`form-control ${
                          pricing.bankInfo ? "filled" : ""
                        }`}
                        placeholder="Bank account or UPI ID"
                        value={pricing.bankInfo}
                        onChange={handlePricingChange}
                      />
                    </Col>
                  </Row>

                  {/* Payment Summary */}
                  <div className="tutor-onboarding-payment-summary mt-4">
                    <h6 className="tutor-onboarding-payment-summary-title mb-3">
                      Payment Summary
                    </h6>
                    <div className="tutor-onboarding-payment-summary-row">
                      <span>Payment Model:</span>
                      <b>
                        {pricing.paymentType === "royalty"
                          ? "Royalty-Based"
                          : "One-Time Settlement"}
                      </b>
                    </div>
                    <div className="tutor-onboarding-payment-summary-row">
                      <span>Course Price:</span>
                      <b>${pricing.basePrice || "0.00"}</b>
                    </div>

                    {/* Only show earnings if Royalty-Based */}
                    {pricing.paymentType === "royalty" && (
                      <div className="tutor-onboarding-payment-summary-row">
                        <span>Your Earnings (70%):</span>
                        <b>
                          $
                          {pricing.basePrice
                            ? (pricing.basePrice * 0.7).toFixed(2)
                            : "0.00"}{" "}
                          per student
                        </b>
                      </div>
                    )}
                  </div>

                  {/* Terms Checkbox */}
                  <div className="tutor-onboarding-about-confirm-box mt-4">
                    <input
                      // className="form-check-input"
                      type="checkbox"
                      id="paymentTerms"
                      // checked={pricing.agreed}
                      // onChange={(e) =>
                      //   setPricing((prev) => ({
                      //     ...prev,
                      //     agreed: e.target.checked,
                      //   }))
                      // }
                    />
                    <label
                      className="form-check-label ms-2"
                      htmlFor="paymentTerms"
                    >
                      I agree to Skilledition Tutor Terms & Conditions and
                      Payment Policy
                    </label>
                  </div>
                </div>
              </Col>
            </Row>

            {/* NAVIGATION BUTTONS */}
            <Row className="justify-content-center">
              <Col lg={10} md={12}>
                <div className="tutor-onboarding-about-buttons">
                  <button
                    className="tutor-onboarding-about-back-btn btn"
                    onClick={() => setCurrentStep((s) => Math.max(1, s - 1))}
                  >
                    <FiChevronLeft size={15} /> Back
                  </button>

                  <button
                    className="tutor-onboarding-about-save-btn btn"
                    onClick={
                      () =>
                        !pricing.basePrice || !pricing.bankInfo
                          ? showErrorToast(
                              "Please fill pricing and bank details.",
                            )
                          : isPricingChanged()
                            ? pricing.payment_plan_id
                              ? handlePricingUpdateSubmit()
                              : handlePricingSubmit()
                            : setCurrentStep((prev) =>
                                Math.min(totalSteps, prev + 1),
                              ) // NO CHANGES, just next
                    }
                  >
                    {!pricing.basePrice || !pricing.bankInfo
                      ? "Save & Continue"
                      : isPricingChanged()
                        ? pricing.payment_plan_id
                          ? "Update & Continue"
                          : "Save & Continue"
                        : "Continue"}
                  </button>
                </div>
              </Col>
            </Row>
          </Container>
        </div>
      )}

      {/* Review & Submit step */}
      {currentStep === 9 && (
        <div className="tutor-onboarding-about-section">
          <Container>
            <Row className="justify-content-center">
              <Col lg={10} md={12}>
                <div className="tutor-onboarding-about-form-container">
                  <h5 className="tutor-onboarding-about-title mb-3">
                    <FaUser className="tutor-onboarding-about-icon me-2" />
                    Review & Submit
                  </h5>
                  <p className="tutor-onboarding-payment-desc">
                    Please review your information before submitting. You can
                    always come back and edit later.
                  </p>

                  {/* Profile Information */}
                  <div className="tutor-onboarding-review-box mt-4">
                    <div className="tutor-onboarding-review-header">
                      <h6>Profile Information</h6>
                      <img
                        src={editIcon}
                        className="tutor-onboarding-review-edit-icon"
                        alt="edit-icon"
                        onClick={() => handleEditClick(1)}
                      />
                    </div>
                    <div className="tutor-onboarding-review-profile">
                      <Row>
                        <Col
                          md={4}
                          sm={12}
                          className="tutor-onboarding-review-profile-col"
                        >
                          <p>
                            <b>Name:</b>
                          </p>
                          <p>{formData.firstName}</p>
                        </Col>
                        <Col
                          md={4}
                          sm={12}
                          className="tutor-onboarding-review-profile-col"
                        >
                          <p>
                            <b>Email:</b>
                          </p>
                          <p>{formData.email}</p>
                        </Col>
                        <Col
                          md={4}
                          sm={12}
                          className="tutor-onboarding-review-profile-col"
                        >
                          <p>
                            <b>Subject:</b>
                          </p>
                          <p>{formData.subject || "Not selected"}</p>
                        </Col>
                      </Row>

                      <div>
                        <p>
                          <b>Languages:</b>
                        </p>
                        <p>{formData.language || "Not selected"}</p>
                      </div>
                    </div>
                  </div>

                  {/* Education */}
                  <div className="tutor-onboarding-review-box">
                    <div className="tutor-onboarding-review-header">
                      <h6>Education</h6>
                      <img
                        src={editIcon}
                        className="tutor-onboarding-review-edit-icon"
                        alt="edit-icon"
                        onClick={() => handleEditClick(4)}
                      />
                    </div>
                    <p className="tutor-onboarding-review-header-para">
                      {educations.length} education record
                      {educations.length !== 1 ? "s" : ""} added
                    </p>
                  </div>

                  {/* Demo Video */}
                  <div className="tutor-onboarding-review-box">
                    <div className="tutor-onboarding-review-header">
                      <h6>Demo Video</h6>
                      <img
                        src={editIcon}
                        className="tutor-onboarding-review-edit-icon"
                        alt="edit-icon"
                        onClick={() => handleEditClick(6)}
                      />
                    </div>
                    <p className="tutor-onboarding-review-header-para">
                      Video uploaded:{" "}
                      {demoVideoFile
                        ? demoVideoFile.name ||
                          (typeof demoVideoFile === "string"
                            ? demoVideoFile.split("/").pop().split("?")[0]
                            : "No video uploaded")
                        : "No video uploaded"}
                    </p>

                    {/* {demoVideoData && (
                      <span
                        className={`tutor-onboarding-review-status ${
                          demoVideoData.status === "reject"
                            ? "reject"
                            : "pending"
                        }`}
                      >
                        {demoVideoData.status === "reject"
                          ? "Rejected"
                          : "Pending Admin Review"}
                      </span>
                    )} */}
                  </div>

                  {/* Pricing & Payment */}
                  <div className="tutor-onboarding-review-box">
                    <div className="tutor-onboarding-review-header">
                      <h6>Pricing & Payment</h6>
                      <img
                        src={editIcon}
                        className="tutor-onboarding-review-edit-icon"
                        alt="edit-icon"
                        onClick={() => handleEditClick(8)}
                      />
                    </div>
                    <div className="tutor-onboarding-review-profile">
                      <Row>
                        <Col md={6}>
                          <p>
                            <b>Payment Model:</b>
                          </p>
                          <p>{pricing.paymentType || "Not selected"}</p>
                        </Col>
                        <Col md={6}>
                          <p>
                            <b>Course Price:</b>
                          </p>
                          <p>
                            {pricing.basePrice
                              ? `$${pricing.basePrice}`
                              : "Not set"}
                          </p>
                        </Col>
                      </Row>
                    </div>
                  </div>

                  {rejectReason && (
                    <div className="tutor-onboarding-reject-box">
                      <p>
                        <b>Rejection Reason:</b> {rejectReason}
                      </p>
                    </div>
                  )}

                  {/* Info Box */}
                  <div className="tutor-onboarding-review-info-box">
                    <h6>What happens next?</h6>
                    <ul>
                      <li>Your profile will be reviewed by our admin team</li>
                      <li>
                        You’ll receive an email notification once approved
                        (usually within 24–48 hours)
                      </li>
                      <li>
                        Once approved, you can access your full tutor dashboard
                        and start creating courses!
                      </li>
                    </ul>
                  </div>

                  {/* Submit Button */}
                  <div className="mt-4">
                    <button
                      className="tutor-onboarding-submit-btn"
                      onClick={handleSubmitAdminReview}
                    >
                      Submit for Admin Review
                    </button>
                  </div>
                </div>
              </Col>
            </Row>
          </Container>
        </div>
      )}
    </>
  );
};

export default TutorOnboarding;
